/*
  Mock data only — no backend yet. We'll replace via API later.
*/

export const PHONE_NUMBER = "+375 (44) 568-69-72"; // TODO: заменить на ваш номер
export const PHONE_TEL = "tel:+375445686972";

export const SERVICES = [
    {
        id: "indiv",
        title: "Индивидуальная психологическая сессия",
        desc: "Диагностика, прояснение запроса, выбор направления работы",
        price: "90 руб / 60 мин",
    },
    {
        id: "emdr",
        title: "Индивидуальная психологическая сессия в методе EMDR",
        desc: "EMDR-переработка травматических переживаний, негативных самопредставлений, формирование новых ассоциативных связей",
        price: "120 руб / 90 мин",
    },
    {
        id: "couple",
        title: "Психологическая сессия для пар",
        desc: "Супружеская и парная терапия, добрачное консультирование и диагностика, решение конфликтов, медиация, консультирование супругов в период предразводного периода и развода",
        price: "120 руб / 90 мин",
    },
    {
        id: "prof",
        title: "Профориентация для подростков и взрослых",
        desc: "Определение интересов, склонностей, мотивов выбора профессии, индивидуально-психологических особенностей на разных возрастных этапах для профессионального самоопределения",
        price: "120 руб / 90 мин",
    },
    {
        id: "group",
        title: "Групповая терапия",
        desc: "Мощный инструмент психологической помощи, соблюдение принципов конфиденциальности, взаимного уважения, безоценочного отношения",
        price: "100 руб / 150 мин",
    },
    {
        id: "training",
        title: "Тренинги",
        desc: "Изменение мышления, формирование новых навыков, мотивация к действиям, поддержка группы",
        price: "100 руб / 150 мин",
    },
];

export const FAQS = [
  {
    q: "Как проходит первая сессия?",
    a: "Мы знакомимся, обсуждаем запрос и желаемый результат, договариваемся о формате и частоте встреч.",
  },
  {
    q: "Онлайн или офлайн?",
    a: "Доступны оба формата. Онлайн — в Zoom/Google Meet. Офлайн — рядом с метро (уточню по телефону).",
  },
  {
    q: "Сколько нужно сессий?",
    a: "Все индивидуально: от 3–5 встреч для точечных задач до более длительной терапии.",
  },
  {
    q: "Можно ли отменить запись?",
    a: "Да, не позднее чем за 24 часа до встречи — без оплаты. Позже — сессия считается проведенной.",
  },
];

export const TESTIMONIALS = [
  {
    id: 1,
    name: "Анна",
    text:
      "Через месяц работы ушла постоянная тревога, я стала спокойнее реагировать на конфликты на работе.",
    role: "продуктовый дизайнер",
  },
  {
    id: 2,
    name: "Игорь",
    text:
      "Получилось восстановить диалог с супругой. Простые техники общения сработали уже на 2-й неделе.",
    role: "предприниматель",
  },
  {
    id: 3,
    name: "Мария",
    text:
      "Поняла, как поддерживать себя без самокритики. Спасибо за бережность и структуру встреч.",
    role: "HR-менеджер",
  },
];
// src/mock.js
export const BLOG_POSTS = [
    {
        id: 'kak-spravlyatsya-s-trevogoj',
        title: "Как справляться с тревогой",
        excerpt: "Практические методы управления тревожностью в повседневной жизни. Узнайте, как снизить уровень стресса и вернуть контроль над эмоциями.",
        date: "15 октября 2024",
        image: "https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80"
    },
    {
        id: 'preodolenie-vygoraniya',
        title: "Преодоление эмоционального выгорания",
        excerpt: "Эффективные стратегии восстановления при профессиональном выгорании. Как вернуть энергию и интерес к работе.",
        date: "10 октября 2024",
        image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80"
    },
    {
        id: 'otnosheniya-i-granitsy',
        title: "Здоровые отношения и личные границы",
        excerpt: "Как устанавливать и защищать личные границы в отношениях. Практические советы для гармоничного общения.",
        date: "5 октября 2024",
        image: "https://images.unsplash.com/photo-1519452635265-7b1fbfd1e4e0?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80"
    },
];

// Генерация доступных слотов на 7 дней вперёд (мок)
const baseTimes = ["10:00", "12:00", "14:00", "16:00", "18:00"];
export const generateSlots = (daysAhead = 7) => {
  const today = new Date();
  const slots = {};
  for (let i = 0; i < daysAhead; i++) {
    const d = new Date(today);
    d.setDate(today.getDate() + i);
    const key = d.toISOString().slice(0, 10);
    slots[key] = baseTimes.map((t) => ({ time: t, available: Math.random() > 0.2 }));
  }
  return slots;
};

export const INITIAL_SLOTS = generateSlots();